module.exports = __webpack_public_path__ + "img/partner22.17047dc3.png";